import { render, staticRenderFns } from "./AlertGraph.vue?vue&type=template&id=45d2b2e2&"
import script from "./AlertGraph.vue?vue&type=script&lang=ts&"
export * from "./AlertGraph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports